module.exports = __webpack_public_path__ + "static/media/logo_mark.1949a558.svg";